<template>
  <div>
    <div class="title-bar clearfix">
      <div class="module pull-left">
        {{ $t("user.title") }}
      </div>
      <div class="btn-group pull-right">
        <el-button :plain="true" size="mini" @click="addUser" v-if="canAddUser">{{ $t("add") }}
          <i class="fa fa-plus"></i>
        </el-button>
        <el-button :plain="true" size="mini" @click="refresh">{{ $t("refresh") }}
          <i class="fa fa-refresh"></i>
        </el-button>
        <el-button :plain="true" size="mini" @click="searchDialogVisible=true">{{ $t("search") }}
          <i class="fa fa-search"></i>
        </el-button>
      </div>
    </div>
    <div class="data-list"
      v-loading="loading"
      element-loading-text="Loading"
    >
      <el-table 
        border
        stripe 
        :data="userData"
        size="mini"
        class="customer-table"
      >
         <el-table-column 
          label="操作"  
          align="center" 
          :resizable="true"
          v-if="canAddUser">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleEdit(scope.$index, scope.row)">{{$t("edit")}}</el-button>
            <el-button type="text" size="small" @click="handleDelete(scope.$index, scope.row)" :disabled="isAdmin(scope.row)">{{$t("delete")}}</el-button>
            <el-button type="text" size="small" @click="resetPassword(scope.$index, scope.row)">{{$t("user.resetPassword")}}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="Email"  align="center" :resizable="true" :label="this.$t('user.email')">
        </el-table-column>
        <el-table-column prop="UserName"  align="center" :resizable="true" :label="this.$t('user.username')">
        </el-table-column>
        <el-table-column prop="Name" align="center"  :resizable="true" :label="this.$t('user.name')">
        </el-table-column>
        <el-table-column prop="Roles"  align="center" :resizable="true" :label="this.$t('user.rolesTitle')" :formatter="RoleFormatter">
        </el-table-column>
      </el-table>

      <el-row class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageIndex"
          :page-sizes="[15,30,50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
        </el-pagination>
      </el-row>

      <el-dialog class="search-dialog" :title="this.$t('search')" :visible.sync="searchDialogVisible" :before-close="handleClose"
        @close="searchDialogClosed()">
        <el-form class="search-form" :model="filter" size="small">
          <el-row :gutter="20">
            <el-col :xs="24" :sm="12" :md="12" :lg="12">
              <el-form-item :label="this.$t('user.username')" size="small" :label-width="searchDialogLabelWidth">
                <el-input v-model="filter.username" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="12" :md="12" :lg="12">
              <el-form-item :label="this.$t('user.email')" size="small" :label-width="searchDialogLabelWidth">
                <el-input v-model="filter.email" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :xs="24" :sm="24" :md="24" :lg="24">
              <el-form-item :label="this.$t('user.rolesPlaceholder')" prop="userRoles" :label-width="searchDialogLabelWidth">
                <el-select v-model="filter.userRoles" multiple size="small">
                  <el-option v-for="role in rolesList" :key="role.value" :label="$t(`user.roles.${role.Name}`)" :value="role.Name"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <div slot="footer" class="search-footer">
          <el-button @click="searchDialogVisible = false" :plain="true" size="mini">{{this.$t('cancel')}}</el-button>
          <el-button type="primary" @click="searchDialogVisible = false;search();" :plain="true" size="mini">{{this.$t('confirm')}}</el-button>
        </div>
      </el-dialog>
     
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
export default {
  name: "UserManagement",
  data() {
    return {
      userData: [],
      filter: {
        username: "",
        email: "",
        userRoles: [],
        name: ""
      },
      rolesList: [],
      searchDialogLabelWidth: "60px",
      pageIndex: 1,
      pageSize: 15,
      totalCount: 0,
      searchDialogVisible: false,
      loading: true
    };
  },
  methods: {
    addUser: function() {
      this.$router.push({ name: "AddUser" });
    },
    RoleFormatter: function(row, column) {
      var roles = row.UserRoles;

      var displayRoles = [];

      var self = this;
      _.forEach(roles, function(value) {
        displayRoles.push(self.$t(`user.roles.${value}`));
      });

      return _.join(displayRoles, ",");
    },
    isAdmin(row) {
      return row.UserRoles.includes("Administrator");
    },
    handleSizeChange(val) {
      this.pageSize = val;
      if (this.pageIndex === 1) {
        this.obtainTableDataAccordingToConditions();
      } else {
        this.pageIndex = 1;
      }
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.obtainTableDataAccordingToConditions();
    },
    handleEdit(index, row) {
      this.$router.push({ name: "EditUser", params: { userId: row.Id } });
    },
    handleDelete(index, row) {
      if (this.isAdmin(row)) {
        this.$message({
          type: "error",
          message: this.$t("user.canNotDeleteAdmin")
        });
        return;
      }
      this.$confirm(
        this.$t("user.confirmDelete", { name: row.Name }),
        this.$t("tip"),
        {
          confirmButtonText: this.$t("confirm"),
          cancelButtonText: this.$t("cancel"),
          type: "warning"
        }
      )
        .then(() => {
          this.$axios
            .delete(`api/users/${row.Id}`)
            .then(response => {
              this.$message({
                type: "success",
                message: this.$t("user.userDeletedSuccessfully")
              });
              this.obtainTableDataAccordingToConditions();
            })
            .catch(err => {
              let msg = err.response
                ? err.response.data
                : this.$t("user.userDeletedUnsuccessfully");
              this.$message({
                type: "error",
                message: msg
              });
            });
        })
        .catch(() => {});
    },
    resetPassword(index, row) {
      this.$router.push({ name: "ResetPassword", params: { userId: row.Id } });
    },
    handleClose(done) {
      done();
    },
    search() {
      this.obtainTableDataAccordingToConditions();
    },
    searchDialogClosed() {
    },
    refresh() {
      this.filter = {
        username: "",
        email: "",
        userRoles: [],
        name: ""
      };
      this.obtainTableDataAccordingToConditions();
    },
    generateFilterOptions() {
      var filterOptions = [];
      if (this.filter.username !== null && this.filter.username.trim() !== "") {
        var filterOption = {
          name: "userName",
          value: this.filter.username
        };

        filterOptions.push(filterOption);
      }

      if (this.filter.email !== null && this.filter.email.trim() !== "") {
        var filterOption = {
          name: "email",
          value: this.filter.email
        };

        filterOptions.push(filterOption);
      }

      if (this.filter.userRoles.length > 0) {
        var selectedRoles = "";
        var count = 0;
        for (var i = 0; i < this.filter.userRoles.length; i++) {
          selectedRoles += this.filter.userRoles[i];
          if (count !== this.filter.userRoles.length - 1) {
            selectedRoles += "%";
          }
          count++;
        }

        var filterOption = {
          name: "userRoles",
          value: selectedRoles
        };
        filterOptions.push(filterOption);
      }

      return JSON.stringify(filterOptions);
    },
    obtainTableDataAccordingToConditions() {
      this.loading = true;
      this.$axios
        .get("api/Users", {
          params: {
            filter: this.generateFilterOptions(),
            pageIndex: this.pageIndex,
            pageSize: this.pageSize
          }
        })
        .then(response => {
          this.userData = response.data.Data;
          this.totalCount = response.data.TotalCount;
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
        });
    }
  },
  computed: {
    ...mapGetters(["roles", "permissions"]),
    canAddUser() {
      return (
        this.roles.includes("Administrator") ||
        this.permissions.find(p => p.toLowerCase() === "user.insert")
      );
    }
  },
  created() {
    this.obtainTableDataAccordingToConditions();
    this.$axios.get("api/Roles").then(response => {
      this.rolesList = response.data;
    });
  }
};
</script>



// WEBPACK FOOTER //
// src/components/application/userManagement/UserManagement.vue